<div class="container">
    <div class="section-title text-start">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <span class="sub-title">NOTRE MISSION</span>
                <h2>Nos <span style="color: var(--mainColor);"><font [size]="13">3</font></span> P </h2>
            </div>
            <!-- <div class="col-lg-6 col-md-12">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                <p class="bottom-zero">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </div> -->
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>Protéger</span></h3>
                <p>Protéger l'enfant au moyen d'une éducation responsable et inclusive.</p>
            </div>
        </div>
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>Promouvoir</span></h3>
                <p>Promouvoir une éducation centrée sur le développement personnel et équilibré de l'enfant.</p>
            </div>
        </div>
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>Palier aux difficultés</span></h3>
                <p>Pallier aux difficultés d'apprentissage des enfants dues aux contextes socio-professionnels et éducatifs de leur environnement.</p>
            </div>
        </div>
    </div>
</div>